import * as actions from '../constants/actions'
import { createReducer } from '../utils/redux'
import { currentPage, maxPage } from '../selectors/selectionPagination'

export default createReducer(1, {

    [actions.SELECTION_PAGINATION_PREVIOUS]: (state, action, fullState) => Math.max(1, currentPage(fullState) - 1),

    [actions.SELECTION_PAGINATION_NEXT]: (state, action, fullState) => Math.min(maxPage(fullState), currentPage(fullState) + 1)

})


// WEBPACK FOOTER //
// ./src/reducers/selectionPagination.js